/*
 * @Description: 所有请求的接口入口
 * @Author: gao shuai
 * @Date: 2020-02-25 15:35:05
 * @LastEditTime: 2020-05-06 14:09:01
 * @LastEditors: gao shuai
 */
import news from './new';
import log from './log';
import systemset from './systemset';
import game from './game';
import apay from './apay';
import merchant from './merchant';
import order from './order';
import money from './money';
import statics from './static';
import chart from './chart';
const _api = {
  news,
  log,
  systemset,
  game,
  apay,
  merchant,
  order,
  money,
  statics,
  chart
};

export default _api;
